// extracted by mini-css-extract-plugin
module.exports = {"wrap":"rate_wrap__2SrCa","star":"rate_star__1tdsF","activeStar":"rate_activeStar__1gAN_"};